<template>

    <table class="w-100 message">
      <tr>
        <td :title='Sender.Name' >
          <img style='height: 40px; width: 40px; border-radius:50%;' :src='Sender.AvatarUrl' v-if='Sender.AvatarUrl'/>
          <img style='height: 40px; width: 40px; border-radius:50%;' src='static/assets/img/avatar.png' v-if='!Sender.AvatarUrl'/>          
        </td>
        <td>
          <table class="w-100">
            <tr>
              <td><strong>{{Sender.Name}}</strong> <span class="time-stamp float-right">{{message.CreatedUtc | formatDate}}</span></td>
            <tr>
            <tr>
              <td><p>{{message.Messages[0].Text}}</p></td>
            </tr>
            <tr class="attachment-row">
              <td v-if='hasAttachment(message)'>
                <message-attachment :message='message'></message-attachment>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
</template>

<script>
  import Avatar from '@/components/Users/Avatar'
  import MessageAttachment from '../Message/MessageAttachment/MessageAttachment'
  import moment from 'moment';

  import {
    PayloadType
  } from '@/lib/utilities/enums'
  export default {
    name: 'message',
    props: ['message'],
    components: {
      Avatar,
      MessageAttachment
    },
    computed: {
      Sender: function () {
        let vm = this;
        if (!vm.$parent._props.group) return {}
        else {
          if (vm.$parent._props.group.Users) {
            let theUser = vm.$parent._props.group.Users.find(function (element) {
              return element.Id == vm.message.SenderId
            })
            if (theUser) return theUser
            else return {
              Name: vm.message.SenderName,
              AvatarUrl: vm.message.SenderAvatarUrl
            }
          }
        }
        return '';
      }
    },
    filters: {
       formatDate: function (dateUTC) {
        if (!dateUTC) return "";

        var date = moment(dateUTC);

        if (!date.isValid()) return "";

        var currentTime = moment();

        var duration = moment.duration(currentTime.diff(date));

        //If today
        if (duration.asDays() < 1 && currentTime.date() === date.date())
          return "Today at " + date.format("hh:mm A");
        else if (duration.asDays() <= 6) {
          return date.calendar();
        } else {
          if (date.year() === currentTime.year())
            return date.format("MMMM Do") + " at " + date.format("hh:mm A");
          else {
            return date.format("MM/DD/YYYY") + " at " + date.format("hh:mm A");
          }
        }
      }
    },
    methods: {
      hasAttachment: function (message) {
        try {
          if (message && message.AttachmentFile) {
            if (
              (message.AttachmentFile.Payload &&
                message.AttachmentFile.PayloadType &&
                message.AttachmentFile.PayloadType ==
                PayloadType.Url) ||
              message.AttachmentFile.PayloadType ==
              PayloadType.Inventory ||
              message.AttachmentFile.PayloadType ==
              PayloadType.Customer ||
              message.AttachmentFile.PayloadType ==
              PayloadType.Giphy ||
              message.AttachmentFile.PayloadType == PayloadType.Form ||
              message.AttachmentFile.PayloadType == PayloadType.Json ||
              message.AttachmentFile.PayloadType == PayloadType.Error
            )
              return true;
            else if (message.AttachmentFile.Url) return true;
          }
        } catch (err) {
          return false;
          console.log(err)
        }
        return false;
      }
    }
  }

</script>
<style lang="scss" scoped>

  table.message {
      border-bottom: 1px solid $gray-lt;
      &:hover {
        background-color: lighten($gray-lt, 7%);
      }
      tr {
        td {
          &:first-child {
            width: 50px;
            vertical-align: top;
            img {
              margin: 8px 15px;
            }
          }
          &:last-child {
            padding-right: 10px;
          }
          .time-stamp {
            font-weight: 300;
            color: $platinum;
            font-size: 0.85em;
            letter-spacing: 0.04em;
            &:hover {
              color: $gray-md;
            }
          }
        }
      }

  }

</style>



// WEBPACK FOOTER //
// src/components/Messenger/MessageList/Message/Message.vue